export const terpeneData = {
  Myrcene: {
    description:
      "A dominant sedative terpene that enhances THC absorption and promotes deep physical relaxation.",
    effects: ["sedating", "muscle relaxation", "sleep support"],
    mental: "Can quiet mental chatter and promote calm but may reduce alertness.",
    physical: "Strong body relaxation, often associated with 'couch-lock'.",
    use: "Best for evening use, pain, insomnia, and muscle tension.",
    thcInteraction:
      "Amplifies THC intensity and duration, often making highs feel heavier and more body-focused."
  },

  Limonene: {
    description:
      "A mood-elevating terpene known for reducing stress and supporting emotional balance.",
    effects: ["uplifting", "anti-anxiety", "mood boost"],
    mental: "Promotes positivity, reduces stress, and may counter depressive feelings.",
    physical: "Light body relaxation without sedation.",
    use: "Ideal for daytime, stress relief, and mood disorders.",
    thcInteraction:
      "Can reduce THC-induced anxiety or paranoia while enhancing the euphoric effects."
  },

  Caryophyllene: {
    description:
      "A unique terpene that directly interacts with the endocannabinoid system (CB2 receptors).",
    effects: ["pain relief", "anti-inflammatory", "stress reduction"],
    mental: "Grounding and stabilizing without sedation.",
    physical: "Targets inflammation, nerve pain, and body discomfort.",
    use: "Best for chronic pain, inflammation, and stress-related tension.",
    thcInteraction:
      "Balances THC effects, making highs feel more controlled and less overwhelming."
  },

  Pinene: {
    description:
      "A clarity-enhancing terpene known for promoting alertness and memory retention.",
    effects: ["focus", "alertness", "memory support"],
    mental: "Improves mental clarity and reduces brain fog.",
    physical: "Opens airways and may support respiratory function.",
    use: "Best for daytime, productivity, and focus-related needs.",
    thcInteraction:
      "May counteract THC-induced memory impairment and help maintain clarity."
  },

  Linalool: {
    description:
      "A calming terpene with strong anxiolytic and sedative properties.",
    effects: ["calming", "anti-anxiety", "sleep support"],
    mental: "Reduces anxiety and promotes emotional calm.",
    physical: "Relaxes the body and may help with tension and restlessness.",
    use: "Best for anxiety, PTSD, and sleep support.",
    thcInteraction:
      "Softens THC intensity, making the experience smoother and less overwhelming."
  },

  Humulene: {
    description:
      "A terpene with anti-inflammatory and appetite-suppressing properties.",
    effects: ["anti-inflammatory", "appetite control"],
    mental: "Neutral mentally but supports overall balance.",
    physical: "Reduces inflammation and may suppress hunger.",
    use: "Best for inflammation, weight control, and physical recovery.",
    thcInteraction:
      "May reduce THC-induced appetite ('munchies')."
  },

  Terpinolene: {
    description:
      "An energizing and slightly stimulating terpene found in many sativa strains.",
    effects: ["energizing", "uplifting", "creative"],
    mental: "Promotes creativity and alertness but can be stimulating.",
    physical: "Light, non-sedating body effect.",
    use: "Best for daytime, creativity, and social activity.",
    thcInteraction:
      "Can amplify THC's cerebral effects, sometimes increasing stimulation."
  },

  Ocimene: {
    description:
      "A light, uplifting terpene associated with energy and clarity.",
    effects: ["energizing", "clear-headed"],
    mental: "Promotes alertness and mental freshness.",
    physical: "Minimal body heaviness.",
    use: "Best for fatigue and low-energy states.",
    thcInteraction:
      "Supports a lighter, more functional THC experience."
  },

  Bisabolol: {
    description:
      "A soothing terpene known for its calming and anti-inflammatory effects.",
    effects: ["calming", "anti-inflammatory"],
    mental: "Reduces stress and promotes gentle relaxation.",
    physical: "Supports skin health and reduces irritation.",
    use: "Best for stress, inflammation, and recovery.",
    thcInteraction:
      "Softens THC intensity and promotes a smoother experience."
  }
};